import { useEffect, useRef } from "react";

const Cursor = () => {
  const blobRef = useRef(null);

  const position = useRef({ x: window.innerWidth / 2, y: window.innerHeight / 2 });
  const target = useRef({ x: window.innerWidth / 2, y: window.innerHeight / 2 });

  useEffect(() => {
    const handlePointerMove = (e) => {
      target.current.x = e.clientX;
      target.current.y = e.clientY;
    };

    const animate = () => {
      const lerp = 0.08; // smaller = slower follow

      position.current.x += (target.current.x - position.current.x) * lerp;
      position.current.y += (target.current.y - position.current.y) * lerp;

      if (blobRef.current) {
        blobRef.current.style.transform = `translate(${
          position.current.x - 125
        }px, ${position.current.y - 125}px)`;
      }

      requestAnimationFrame(animate);
    };

    document.addEventListener("pointermove", handlePointerMove);
    requestAnimationFrame(animate);

    return () => document.removeEventListener("pointermove", handlePointerMove);
  }, []);

  return <div id="cursorBlob" ref={blobRef}></div>;
};

export default Cursor;
